import React from 'react';
import { observer } from 'mobx-react';
import ReactPlayer from 'react-player';
import { Container, AdItem, VideoContainer, FadeTransition } from './styles';
import { useBannerSportCheer, isVideoUrl, isValidUrl, isIOS, isAndroid, getContactUsHref } from './useBannerSportCheer';
import { hasCachedVideoData } from '../../common/cache/mediaCache';
import CachedImage from './CachedImage';

const DefaultLeftBanner = '/images/sport_cheer_banner/sport_cheer_banner_left.png';
const DefaultRightBanner = '/images/sport_cheer_banner/sport_cheer_banner_right.png';

const BannerSportCheer = observer(() => {
  const {
    fetchingBanner,
    leftBannerIndex,
    rightBannerIndex,
    currentLeftBanner,
    currentRightBanner,
    handleVideoProgress,
    handleVideoDuration,
  } = useBannerSportCheer();

  const getBannerHref = (banner) => {
    if (!banner) return getContactUsHref();
    let href = '';
    if (isIOS() && banner?.hrefIos) {
      href = banner.hrefIos;
    } else if (isAndroid() && banner?.hrefAndr) {
      href = banner.hrefAndr;
    } else if (banner?.href) {
      href = banner.href;
    }
    return isValidUrl(href) ? href : '#';
  };

  const handleBannerLeftClick = (e, banner) => {
    e.preventDefault();

    handleBannerClick(e, banner);
  };

  const handleBannerRightClick = (e, banner) => {
    e.preventDefault();

    handleBannerClick(e, banner);
  };

  const handleBannerClick = (e, banner) => {
    if (!banner) {
      const contactUsHref = getContactUsHref();
      window.open(contactUsHref, '_blank');
      return;
    }

    const href = getBannerHref(banner);
    if (href !== '#' && isValidUrl(href)) {
      window.open(href, banner?.target || '_blank');
    }
  };

  const renderBannerContent = (banner, defaultImage, isLeft) => {
    if (!banner?.imgPath) {
      if (fetchingBanner) {
        return null;
      }

      return <img src={defaultImage} alt='banner' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />;
    }

    if (isVideoUrl(banner?.imgPath)) {
      return (
        <VideoContainer>
          <div style={{ opacity: hasCachedVideoData(banner?.imgPath) ? 1 : 0 }}>
            <ReactPlayer
              url={banner?.imgPath}
              playing={true}
              controls={false}
              loop={true}
              muted={true}
              playsinline={true}
              onDuration={(duration) => handleVideoDuration(duration, isLeft)}
              onProgress={({ played }) => handleVideoProgress(played, isLeft)}
              width='100%'
              height='100%'
              style={{ backgroundColor: 'transparent', zIndex: 1 }}
            />
          </div>
        </VideoContainer>
      );
    }

    return (
      <CachedImage
        src={banner?.imgPath}
        alt={banner.title || 'banner'}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    );
  };

  return (
    <Container>
      <AdItem
        href={getBannerHref(currentLeftBanner)}
        onClick={(e) => handleBannerLeftClick(e, currentLeftBanner)}
        target={currentRightBanner?.target || '_blank'}
        id='sport_mobile_banner_left'
      >
        <FadeTransition key={leftBannerIndex}>
          {renderBannerContent(currentLeftBanner, DefaultLeftBanner, true)}
        </FadeTransition>
      </AdItem>
      <AdItem
        href={getBannerHref(currentRightBanner)}
        onClick={(e) => handleBannerRightClick(e, currentRightBanner)}
        target={currentRightBanner?.target || '_blank'}
        id='sport_mobile_banner_right'
      >
        <FadeTransition key={rightBannerIndex}>
          {renderBannerContent(currentRightBanner, DefaultRightBanner, false)}
        </FadeTransition>
      </AdItem>
    </Container>
  );
});

export default BannerSportCheer;
